import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import moment from 'moment';

export class AllTimeDateRangePicker extends React.Component {
  static propTypes = {
    displayedDates: PropTypes.shape({
      start: PropTypes.date,
      finish: PropTypes.date,
    }).isRequired,
    clickPrevious: PropTypes.func.isRequired,
    clickNext: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
  };

  render() {
    const formattedStart = moment(this.props.displayedDates.start).format(
      'M/D/YY',
    );
    const formattedFinish = moment(this.props.displayedDates.finish).format(
      'M/D/YY',
    );
    // The crazy button class stack here is to get a combo of ds styles and
    // old btn-group styles
    const buttonClasses = classNames(
      'btn btn-default u-fw700 u-tcGrayDarkest Button Button--inverseGray Button--sm u-borderColorGray u-hover-bgColorGray u-textCapitalize',
      {
        disabled: this.props.isDisabled,
      },
    );

    const style = {
      opacity: this.props.isDisabled ? 0.5 : 1,
    };

    return (
      <div className="btn-group" style={{ zIndex: 0 }}>
        <button
          className={classNames(buttonClasses, 'Button--square')}
          onClick={this.props.clickPrevious}
          style={style}
        >
          <i className="fa fa-angle-left fa-lg"></i>
        </button>

        <button
          className={classNames(
            buttonClasses,
            'u-bgColorWhite u-borderColorGray',
          )}
          disabled="disabled"
          style={style}
        >
          {formattedStart}–{formattedFinish}
        </button>

        <button
          className={classNames(buttonClasses, 'Button--square')}
          onClick={this.props.clickNext}
          style={style}
        >
          <i className="fa fa-angle-right fa-lg"></i>
        </button>
      </div>
    );
  }
}
